var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0126 0C4.49108 0 0 4.45393 0 9.92976C0 15.4056 4.49108 19.8605 10.0126 19.8605C15.5341 19.8605 20.0262 15.4056 20.0262 9.92976C20.0262 4.45393 15.5341 0 10.0126 0ZM10.0126 19.066C4.93415 19.066 0.801218 14.9672 0.801218 9.93078C0.801218 4.89435 4.93415 0.794586 10.0126 0.794586C15.091 0.794586 19.226 4.89232 19.226 9.93078C19.226 14.9692 15.093 19.066 10.0126 19.066Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3682 9.93077C16.3682 10.4727 15.9251 10.9121 15.3776 10.9121H4.64573C4.09829 10.9121 3.65625 10.4727 3.65625 9.93077C3.65625 9.38887 4.09829 8.94946 4.64573 8.94946H15.3776C15.9251 8.94946 16.3682 9.38887 16.3682 9.93077Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0129 3.62671C10.5604 3.62671 11.0024 4.06612 11.0024 4.60903V15.2522C11.0024 15.7951 10.5604 16.2335 10.0129 16.2335C9.4665 16.2335 9.02344 15.7961 9.02344 15.2522V4.60903C9.02344 4.06612 9.4665 3.62671 10.0129 3.62671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a15d1faacfda3ca0c906244aaace1152.svg";
export { ForwardRef as ReactComponent };